// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"4ccaa2d1","513":"a69c90c3","703":"448e5c82","787":"cb57cd53"}[chunkId] + ".chunk.js";
};